import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, CircularProgress, Stack, Typography } from '@mui/material';
import { fetchTicketureAllEventIDs } from '../services/ticketure';

const EventIdsDump = () => {
  const dispatch = useDispatch();
  const { allEventIds, loading, error } = useSelector((state) => state.ticketure);

  useEffect(() => {
    if (!allEventIds || allEventIds.length === 0) {
      dispatch(fetchTicketureAllEventIDs());
    }
  }, [dispatch, allEventIds]);

  const handleRefresh = () => {
    dispatch(fetchTicketureAllEventIDs());
  };

  return (
    <Box sx={{ p: 3 }}>
      <Stack spacing={2}>
        <Stack direction="row" spacing={2} alignItems="center">
          <Typography variant="h5">Event ID Payload</Typography>
          <Button variant="outlined" onClick={handleRefresh} disabled={loading}>
            {loading ? 'Refreshing…' : 'Refresh'}
          </Button>
        </Stack>

        {loading && (
          <Stack direction="row" spacing={1} alignItems="center">
            <CircularProgress size={20} />
            <Typography variant="body2">Loading latest event IDs…</Typography>
          </Stack>
        )}

        {error && (
          <Typography color="error">
            {error}
          </Typography>
        )}

        <Box component="pre" sx={{
          p: 2,
          borderRadius: 1,
          backgroundColor: '#0b0d17',
          color: '#e3e8ff',
          fontSize: 13,
          overflow: 'auto',
          maxHeight: '70vh',
          border: '1px solid rgba(255,255,255,0.1)'
        }}>
          {JSON.stringify(allEventIds || [], null, 2)}
        </Box>
      </Stack>
    </Box>
  );
};

export default EventIdsDump;

